import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/homepage/features/direct2025/pp11.png")